<template>
  <body>
    <div class="account-pages my-5 pt-sm-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <sendemail
              :isSendEmail="isSendEmail"
              :_setEmail="_setEmail"
              :form="form"
            />

            <verification
              :isSendEmail="isSendEmail"
              :emailForgot_="emailForgot_"
              :_sendVerification="_sendVerification"
            />

            <newpassword
              :isSendEmail="isSendEmail"
              :_setEmail="_setEmail"
              :form="form"
            />

            <div class="mt-5 text-center">
              <div>
                <p>
                  <a
                    href="https://siplah.eurekabookhouse.co.id/satdik/site/tutorial"
                    target="_blank"
                    class="fw-medium text-primary"
                  >
                    Dokumentasi
                  </a>
                </p>
                <p>Copyright © 2009 - 2021, SIPlah. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import $ from "jquery";
import verification from "../components/auth/verification.vue";
import sendemail from "../components/auth/sendemail.vue";
import newpassword from '../components/auth/newpassword.vue'
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
  components: {
    verification,
    sendemail,
    newpassword
  },
  data() {
    return {
      form: {
        email: " ",
      },
      errors: "",
      codeInput: "",
    };
  },
  computed: {
    ...mapGetters(["emailForgot_"]),
    isSendEmail() {
      return this.$route.query._stepforgot;
    },
  },
  mounted() {
    this.forDisplay();
    if(this.isSendEmail == 1){
      this._nextInput();
    }

    const _getEmail = localStorage.getItem("_localemail");
    const _getIsCodeDone = localStorage.getItem("isSendCode");

    if (_getEmail === null || _getEmail === "") {
      localStorage.removeItem("_localemail");
      localStorage.removeItem('isSendCode')
      this.backToEmail();
    } else if(_getIsCodeDone){
      this.$router
        .replace({ path: "forgot", query: { _stepforgot: 2 } })
        .catch(() => {});
    } 
    else {
      this.$router
        .replace({ path: "forgot", query: { _stepforgot: 1 } })
        .catch(() => {});
    }
  },

  methods: {
    async _setEmail(val){
      await axios.post('user/forgotPassword/seller', {
        email:val
      })
      .then((res)=>{
        if(res.data.status.code != 200){
          this.$toast.error(res.data.status.message)
        } else {
          this.$store.commit('setEmail', val)
          localStorage.setItem("_localemail", val);
          this.sendEmail();
          this.$toast.success(res.data.status.message)
        }
      })
    },
    _sendVerification() {
      let code = "";
      for (let i = 1; i < 7; i++) {
        const str = $(`#code${i}`).val();
        code += str;
      }
      this.codeInput = code;
    },
    _nextInput() {
      //   const gthis = this;
      $("input").keyup(function () {
        var index = $(this).index("input");
        if ($(this).val() != "") {
          $("input")
            .eq(index + 1)
            .focus();
        }

        // if (index + 1 == 6) {
        //   gthis.$toast.success("wow");
        // }
      });
    },
    toRegister() {
      this.$router.push({
        path: "/register",
      });
    },
    sendEmail() {
      this.$router
        .replace({ path: "forgot", query: { _stepforgot: 1 } })
        .catch(() => {});
    },
    backToEmail() {
      this.$router
        .replace({ path: "forgot", query: { _stepforgot: 0 } })
        .catch(() => {});
    },
    forDisplay() {
      // $('#password').val('')
      $("#password").on("click", function () {
        $("#password").val("");
        // this.form.password = ''
        // console.log(this.form.password)
        // $('#password').attr('type', 'text')
      });

      const matchSize = window.screen.availWidth;

      if (matchSize < 768) {
        $("#pictureOffice").hide();
      } else {
        $("#pictureOffice").show();
      }
      $(window).on("resize", function () {
        if ($(window).width() < 768) {
          $("#pictureOffice").hide();
        } else {
          $("#pictureOffice").show();
        }
      });

      // const matchSize = window.screen.availWidth;
      // if (matchSize < 768) {
      //   $(".login-card-img").hide();
      //   $(".form-horizontal").css("display", "inline-block");
      //   $(".card-body").addClass("text-center");
      // } else {
      //   $(".login-card-img").show();
      //   $(".form-horizontal").css("display", "");
      //   $(".card-body").removeClass("text-center");
      // }
      // $(window).on("resize", function () {
      //   if ($(window).width() < 768) {
      //     $(".login-card-img").hide();
      //     $(".form-horizontal").css("display", "inline-block");
      //     $(".card-body").addClass("text-center");
      //   } else {
      //     $(".login-card-img").show();
      //     $(".form-horizontal").css("display", "");
      //     $(".card-body").removeClass("text-center");
      //   }
      // });
    },
  },
};
</script>


